// @flow
import React from 'react'

import { colors } from 'components/common'
import { GenericMapperController } from './genericMapperController/genericMapperComponent'
import { useI18n } from '~/core/i18n'

type HeadersControllerProps = {
  name: string,
  label?: string
}

const HeadersController = ({ name, label, ...props }: HeadersControllerProps) => {
  const [msg] = useI18n()
  return (
    <GenericMapperController
      customFields={[
        { id: 'headers-name-input', type: 'input', name: 'name', label: msg('common.controllers.headers.name') },
        {
          id: 'headers-value-textarea',
          type: 'textarea',
          name: 'value',
          label: msg('common.controllers.headers.value'),
          rows: 4
        }
      ]}
      customItemContent={header => [
        { label: msg('common.labels.name'), value: header.name, color: colors.blue500 },
        { label: msg('common.controllers.headers.value'), value: header.value }
      ]}
      customTexts={{
        modalTitle: msg('common.controllers.headers.editHeader'),
        addMapping: msg('common.controllers.headers.addHeader')
      }}
      label={label}
      name={name}
      {...props}
    />
  )
}

export { HeadersController }
